import moment from "moment";
import React from "react";
import Chart from "react-apexcharts";

type LineChartProps = {
  data?: { x: string; y: number }[]; // Optional data prop
  width?: string | number;
  height?: string | number;
  lineColor?: string;
};

const LinechartMini: React.FC<LineChartProps> = ({
  data,
  width = "100%",
  height = "120px",
  lineColor
}) => {


  // Use passed data or fallback to defaultData if it's empty or undefined
  const validatedData = data || []

  const options: ApexCharts.ApexOptions = {
    chart: {
      id: "basic-line",
      background: "transparent",
      toolbar: { show: false },
      zoom: {enabled:false}
    },
    xaxis: {
      type: "datetime",
      labels: { show: false, style:{colors:'white'} },
      axisBorder: { show: false},
      axisTicks: { show: false },
      tooltip: { enabled: false },
    },
    yaxis: {
      axisBorder: {
        show: false,
        color: "#ccc",
        width: 1,
      },
      labels: { show: false, style:{colors:'white'}},
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: [lineColor],
    },
    tooltip: {
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const price = series[seriesIndex][dataPointIndex];
        const time = new Date(
          w.globals.seriesX[seriesIndex][dataPointIndex]
        ).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        const date = moment(w.globals.seriesX[seriesIndex][dataPointIndex]).format("MM-DD-YYYY");
        return `<div style="background-color: #333; display: flex; gap: 5px; color: #fff; padding: 5px; border-radius: 5px;">
                  <span>$${price.toFixed(2)}</span>
                  <span>|</span>
                  <span>${date}</span>
                </div>`;
      },
    },
    grid: { show: false },
    markers: {
      size: 0,
      colors: ["#FFFFFF"],
      strokeWidth: 5,
      strokeColors: lineColor,
      hover: { size: 7 },
    },
  };

  const series: ApexAxisChartSeries = [
    {
      name: "Price",
      data: validatedData,
    },
  ];

  return (
    <div className="line-chart">
      <Chart options={options} series={series} type="line" width={width} height={height} />
    </div>
  );
};

export default LinechartMini;
